import React, { createContext, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import {
  customerAlsoConsidering,
  locationSlashStateActivityExecuted,
  mdfActivityType as internalMdfActivityType,
  mdfCreditActivityType as internalMdfCreditActivityType,
  migrationPhase,
  pifWorkloads,
  projectType,
  sandboxDesignWinActivity,
  specializedWorkloads,
  thirdPartyFunding,
  existingWorkloadSource,
  awsArrCalculationType,
} from "../../../shared/util/constants/staticOptions";
import {
  loadCountries,
  loadCurrencies,
} from "../services/data/InternalDataService";
import { mapLiteCheck } from "../../../shared/util/constants/smpMapLite";
import { isFeatureEnabled } from "../../../shared/util/services/features/FeatureFlagsService";
import { FEATURE_FLAG_ENUMS } from "../../../shared/util/constants/featureFlagValues";
import { getSelfServiceOptions } from "../../../shared/util/common/selfServiceUtil";

const OptionsContext = createContext();

const useOptionsContext = () => useContext(OptionsContext);

const loadStatic = (specializedWorkloads) => ({
  sandboxDesignWinActivity,
  locationSlashStateActivityExecuted,
  projectType,
  customerAlsoConsidering,
  migrationPhase,
  specializedWorkloads,
  thirdPartyFunding,
  pifWorkloads,
  existingWorkloadSource,
  awsArrCalculationType,
});

const OptionsProvider = ({ children, data }) => {
  const [options, setOptions] = React.useState({ isLoading: true });

  useEffect(() => {
    const featureFlag = async () => {
      const expandSpecializedWorkloadsFlag = await isFeatureEnabled(
        FEATURE_FLAG_ENUMS.EXPAND_SPECIALIZED_WORKLOADS_ENABLED
      );
      const selfServiceMdfActivityTypeFlag = await isFeatureEnabled(
        FEATURE_FLAG_ENUMS.SELF_SERVICE_FUND_REQUEST_MDF_ACTIVITY_TYPE
      );
      const countries = await loadCountries();
      const currencies = await loadCurrencies();

      const mdfActivityType = selfServiceMdfActivityTypeFlag
        ? await getSelfServiceOptions("FundRequestMdfCashActivityType")
        : internalMdfActivityType;
      const mdfCreditActivityType = selfServiceMdfActivityTypeFlag
        ? await getSelfServiceOptions("FundRequestMdfCreditActivityType")
        : internalMdfCreditActivityType;
      const staticOptions = loadStatic(
        setSpecializedWorkloads(data, expandSpecializedWorkloadsFlag)
      );
      if (!ignore) {
        setOptions({
          isLoading: false,
          countries,
          currencies,
          mdfActivityType,
          mdfCreditActivityType,
          ...staticOptions,
        });
      }
    };

    let ignore = false;
    featureFlag();
    return () => {
      ignore = true;
    };
  }, []);

  return (
    <OptionsContext.Provider value={[options, setOptions]}>
      {children}
    </OptionsContext.Provider>
  );
};

const setSpecializedWorkloads = (data, expandSpecializedWorkloadsFlag) => {
  const specializedWorkloadsLargeMap = specializedWorkloads.filter(
    (workload) => !workload.validOnlyForMapLite
  );
  let specializedWorkloadsforMapLite = expandSpecializedWorkloadsFlag
    ? specializedWorkloads
    : specializedWorkloadsLargeMap;

  return mapLiteCheck(data)
    ? specializedWorkloadsforMapLite
    : specializedWorkloadsLargeMap;
};

OptionsProvider.propTypes = {
  children: PropTypes.element.isRequired,
  defaultOptions: PropTypes.object,
  data: PropTypes.object,
};

export { useOptionsContext, OptionsProvider };
